import { render, staticRenderFns } from "./AdvancedTrends.vue?vue&type=template&id=b95aa8d2"
import script from "./AdvancedTrends.vue?vue&type=script&lang=js"
export * from "./AdvancedTrends.vue?vue&type=script&lang=js"
import style0 from "./AdvancedTrends.vue?vue&type=style&index=0&id=b95aa8d2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports